export const formatPhone = phone => {
  if (phone.slice(0, 2) === '+1') {
    // NANP
    const match = phone.slice(2).match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
  }
  return phone
}
